import { ColumnType } from 'antd/lib/table';
import cleanObject from './cleanObject';

const allColumnsByData = (data: any) => {
  const allDataIndex: any = [];
  data?.forEach((line: any) => {
    allDataIndex.push(...Object.keys(cleanObject(line)));
  }, []);
  // @ts-ignore
  return [...new Set(allDataIndex), 'actions']; // Remove duplicated values
};

export const filterColumnsByData = (data: any, columns: ColumnType<any>[]) => {
  if (data?.length > 0) {
    return columns.filter(column => {
      return allColumnsByData(data).includes(column.dataIndex);
    });
  }
  return columns;
};
